import { useI18n } from "#imports"

export function useDate () {
    const i18n = useI18n()
    const currentLocaleLanguage = (i18n as { localeProperties?: { value?: { language?: string } } }).localeProperties?.value?.language ?? undefined

    const formatDate = function (date: ConstructorParameters<typeof Date>[0]) {
        return new Date(date).toLocaleDateString(currentLocaleLanguage,
            {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            })
    }

    return {
        formatDate
    }
}
